import { NavLink } from 'react-router-dom';
import { ClipboardList, Home, MessageSquareHeart } from 'lucide-react';
import { cn } from '@/lib/utils';
import { useMyRequests } from '@/contexts/RequestsContext';

const TABS = [
  { to: '/', label: 'Home', icon: Home, end: true },
  { to: '/requests', label: 'Requests', icon: ClipboardList, end: false },
  { to: '/feedback', label: 'Feedback', icon: MessageSquareHeart, end: false },
];

/**
 * The tab bar from the reference design, trimmed to the destinations this
 * app has. Fixed to the viewport and capped to the shell's width so it sits
 * under the column on wide screens rather than spanning the window.
 */
export function BottomNav() {
  const { unreadCount } = useMyRequests();
  return (
    <nav
      aria-label="Main"
      className="bg-card fixed inset-x-0 bottom-0 z-40 border-t pb-[env(safe-area-inset-bottom)]"
    >
      <ul className="mx-auto flex h-16 max-w-md items-stretch">
        {TABS.map(({ to, label, icon: Icon, end }) => (
          <li key={to} className="flex-1">
            <NavLink
              to={to}
              end={end}
              className={({ isActive }) =>
                cn(
                  'flex h-full flex-col items-center justify-center gap-1 text-[11px] font-medium transition-colors',
                  isActive ? 'text-primary' : 'text-muted-foreground hover:text-foreground',
                )
              }
            >
              <span className="relative">
                <Icon className="size-5" aria-hidden="true" />
                {to === '/requests' && unreadCount > 0 && (
                  <span
                    className="bg-destructive text-destructive-foreground absolute -top-1.5 -right-2 flex h-4 min-w-4 items-center justify-center rounded-full px-1 text-[10px] font-bold"
                    aria-label={`${unreadCount} updates`}
                  >
                    {unreadCount > 9 ? '9+' : unreadCount}
                  </span>
                )}
              </span>
              {label}
            </NavLink>
          </li>
        ))}
      </ul>
    </nav>
  );
}
